import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  Tooltip,
  Autocomplete,
  Box,
  Card,
  Stack,
} from "@mui/material";
import { MentorSchedule } from "./schedule";
import { useGlobal } from "../context/GlobalProvider";
import {
  createScheduleRow,
  editScheduleRow,
  getSchedule,
} from "../api/schedule";
import { makeScheduleCols } from "../columns/makeScheduleColumns";
import { useEffect } from "react";
import { getEventMatches } from "../api/event";

async function GetSchedule(team, event) {
  const data = await getSchedule({
    team: team,
    event: event,
    user_id: "",
  });
  return data;
}

async function GetEventMatches(event) {
  console.log("getting");
  try {
    const data = await getEventMatches(event, "");
    return data;
  } catch (error) {
    console.error("Error fetching matches:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export function ScheduleManager({ user, currentEvent }) {
  const { eventList } = useGlobal();
  const [hasSchedule, setHasSchedule] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);
  const [eventSelected, setEventSelected] = useState(null);
  const [groups, setGroups] = useState([]);
  const [numMatches, setNumMatches] = useState(0);
  const [pendingChanges, setPendingChanges] = useState([]);
  useEffect(() => {
    console.log(pendingChanges);
  }, [pendingChanges]);

  useEffect(() => {
    if (eventSelected != null) {
      const fetchScheduleData = async () => {
        const result = await GetSchedule(
          user?.team_number,
          eventSelected?.value
        );
        try {
          const parsedData = JSON.parse(result?.body);
          setHasSchedule(parsedData?.data.length !== 0);
          setScheduleData(parsedData?.data);
        } catch (error) {
          setScheduleData([]);
          console.error("Error parsing schedule data:", error);
        }
      };

      fetchScheduleData();
      const fetchData = async () => {
        const result = await GetEventMatches(eventSelected.value);
        try {
          console.log(result.length);
          setNumMatches(result.length);
        } catch (error) {
          console.error("Error parsing user data:", error);
          setNumMatches(0);
        }
      };

      fetchData();
    }
  }, [eventSelected]);

  useEffect(() => {
    if (currentEvent != null) {
      setEventSelected(
        eventList.filter((event) => event.value === currentEvent)[0]
      );
    }
  }, [currentEvent]);

  const handleSave = async () => {
    const results = await Promise.all(
      pendingChanges.map((change) => {
        let tmpChange = { ...change };
        tmpChange.team_number = user.team_number;
        tmpChange.event = eventSelected.value;
        console.log(tmpChange);
        if (tmpChange.schedule_id != null) {
          return editScheduleRow(tmpChange);
        } else {
          return createScheduleRow(tmpChange);
        }
      })
    );
    setPendingChanges([]);
  };

  return (
    <Grid container sx={{ mt: 3 }} spacing={2}>
      <Grid item xs={12}>
        <Typography sx={{ textAlign: "center" }}>
          <b>Manage Schedules</b>
        </Typography>
      </Grid>
      <Grid item xs={12} lg={4} sx={{ display: hasSchedule ? "flex" : "flex" }}>
        <Stack
          spacing={2}
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
          }}
        >
          <Card
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: 5,
              backgroundColor: "background.light",
            }}
          >
            <Grid container sx={{ mt: 3 }} spacing={2}>
              <Grid item xs={12} sx={{ display: "flex", width: "100%" }}></Grid>
            </Grid>
          </Card>
          <Card
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: 5,
              backgroundColor: "background.light",
            }}
          >
            <Grid container sx={{ mt: 3 }} spacing={2}>
              <Grid item xs={12} sx={{ display: "flex", width: "100%" }}></Grid>
            </Grid>
          </Card>
        </Stack>
      </Grid>
      <Grid item xs={12} lg={8} sx={{ display: hasSchedule ? "flex" : "flex" }}>
        <Grid container sx={{ mt: 3 }} spacing={2}>
          <Grid item xs={4} sx={{ display: "flex", width: "100%" }}>
            <Tooltip
              title={
                <React.Fragment>
                  <Typography>Search By...</Typography>
                  {"- Event Name"}
                  <br />
                  {"- Event Code"}
                  <br />
                  {"- Location"}
                </React.Fragment>
              }
              placement="top"
              arrow
            >
              <Autocomplete
                name="event"
                value={eventSelected}
                options={eventList}
                groupBy={(option) => option.week}
                getOptionKey={(option) => option.value}
                getOptionLabel={(option) => option?.label}
                filterOptions={(options, { inputValue }) => {
                  const filtered = options.filter(
                    (option) =>
                      option?.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()) ||
                      option?.eventCode
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()) ||
                      option?.location
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                  );
                  return filtered;
                }}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  setEventSelected(newValue);
                  console.log(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Event" variant="filled" />
                )}
                sx={{ width: "100%" }}
              />
            </Tooltip>
          </Grid>
          <Grid item xs={8} sx={{ display: "flex", width: "100%" }}>
            <Button
              variant="contained"
              sx={{ width: "100%" }}
              onClick={() => handleSave()}
            >
              Save Changes
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                width: "100%",
                borderRadius: 5,
                backgroundColor: "background.light",
              }}
            >
              <MentorSchedule
                user={user}
                scheduleData={scheduleData}
                numMatches={numMatches}
                setPendingChanges={setPendingChanges}
              />
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
